import { httpRequest } from 'http'
import {
    clan_supply_progression_progress_mock,
} from '../../containers/ClanLanding/mocks/clan_supply_progression_progress_mock'

export const CLAN_SUPPLY_PROGRESSION_REQUEST = 'clan_supply_progression/INFO_REQUEST'
export const CLAN_SUPPLY_PROGRESSION_SUCCESS = 'clan_supply_progression/INFO_SUCCESS'
export const CLAN_SUPPLY_PROGRESSION_ERROR = 'clan_supply_progression/INFO_ERROR'

export function clanSupplyProgressionRequestStart() {
    return {
        type: CLAN_SUPPLY_PROGRESSION_REQUEST,
    }
}

export function clanSupplyProgressionRequestSuccess(data) {
    return {
        type: CLAN_SUPPLY_PROGRESSION_SUCCESS,
        payload: data,
    }
}

export function clanSupplyProgressionRequestError(errorData) {
    return {
        type: CLAN_SUPPLY_PROGRESSION_ERROR,
        payload: errorData,
    }
}

export const REQUEST_INTERVAL = 5000

export function requestClanSupplyProgressionInfo() {
    return async (dispatch, getState) => {
        const state = getState()
        const requestNotPossibleByTimeout = state.clanSupplyProgression.lastRequestTimestamp &&
            (Date.now() - state.clanSupplyProgression.lastRequestTimestamp) < REQUEST_INTERVAL
        if (state.clanSupplyProgression.loading || requestNotPossibleByTimeout) {
            return
        }

        dispatch(clanSupplyProgressionRequestStart())

        try {
            const request = process.env.API_ENV === 'mock' ?
                clan_supply_progression_progress_mock() :
                httpRequest(`${window.config.WGCG_API_URL}/clansupply/landing/campaign_map/progress/`)

            const data = await request

            dispatch(clanSupplyProgressionRequestSuccess(data))
        } catch (errorData) {
            if (errorData.statusCode === 503) {
                dispatch(clanSupplyProgressionRequestSuccess({ enabled: false }))

                return
            }
            dispatch(clanSupplyProgressionRequestError(errorData))
        }
    }
}



// WEBPACK FOOTER //
// ./state/actions/clan_supply_progression.js